export enum EmailSubjectPrefixesEnum {
  RE = 'RE:',
  FWD = 'FWD:',
}
